import { createAction } from '@af-common/Common/_actions/Action';

export enum HIDActionType {
	OnSpaceDown       = 'HID_ON_SPACE_DOWN',
	OnSpaceUp         = 'HID_ON_SPACE_UP',
	OnModDown         = 'HID_ON_MOD_DOWN',
	OnModUp           = 'HID_ON_MOD_UP',
	OnShiftDown       = 'HID_ON_SHIFT_DOWN',
	OnShiftUp         = 'HID_ON_SHIFT_UP',
	OnAltDown         = 'HID_ON_ALT_DOWN',
	OnAltUp           = 'HID_ON_ALT_UP',
	OnPlusDown        = 'HID_ON_PLUS_DOWN',
	OnMinusDown       = 'HID_ON_MINUS_DOWN',
	OnDeleteDown      = 'HID_ON_DELETE_DOWN',
	OnShiftDeleteDown = 'HID_ON_SHIFT_DELETE_DOWN',
	OnLeftDown        = 'HID_ON_LEFT_DOWN',
	OnRightDown       = 'HID_ON_RIGHT_DOWN',
	OnUpDown          = 'HID_ON_UP_DOWN',
	OnDownDown        = 'HID_ON_DOWN_DOWN',
	OnShiftLeftDown   = 'HID_ON_SHIFT_LEFT_DOWN',
	OnShiftRightDown  = 'HID_ON_SHIFT_RIGHT_DOWN',
	OnShiftUpDown     = 'HID_ON_SHIFT_UP_DOWN',
	OnShiftDownDown   = 'HID_ON_SHIFT_DOWN_DOWN',
}

export const OnSpaceDown       = () => createAction(HIDActionType.OnSpaceDown);
export const OnSpaceUp         = () => createAction(HIDActionType.OnSpaceUp);
export const OnModDown         = () => createAction(HIDActionType.OnModDown);
export const OnModUp           = () => createAction(HIDActionType.OnModUp);
export const OnShiftDown       = () => createAction(HIDActionType.OnShiftDown);
export const OnShiftUp         = () => createAction(HIDActionType.OnShiftUp);
export const OnAltDown         = () => createAction(HIDActionType.OnAltDown);
export const OnAltUp           = () => createAction(HIDActionType.OnAltUp);
export const OnPlusDown        = () => createAction(HIDActionType.OnPlusDown);
export const OnMinusDown       = () => createAction(HIDActionType.OnMinusDown);
export const OnDeleteDown      = () => createAction(HIDActionType.OnDeleteDown);
export const OnShiftDeleteDown = () => createAction(HIDActionType.OnShiftDeleteDown);
export const OnLeftDown        = () => createAction(HIDActionType.OnLeftDown);
export const OnRightDown       = () => createAction(HIDActionType.OnRightDown);
export const OnUpDown          = () => createAction(HIDActionType.OnUpDown);
export const OnDownDown        = () => createAction(HIDActionType.OnDownDown);
export const OnShiftLeftDown   = () => createAction(HIDActionType.OnShiftLeftDown);
export const OnShiftRightDown  = () => createAction(HIDActionType.OnShiftRightDown);
export const OnShiftUpDown     = () => createAction(HIDActionType.OnShiftUpDown);
export const OnShiftDownDown   = () => createAction(HIDActionType.OnShiftDownDown);

export type HIDAction = 
	ReturnType<typeof OnSpaceDown>	|
	ReturnType<typeof OnSpaceUp>	|
	ReturnType<typeof OnModDown>	|
	ReturnType<typeof OnModUp>		|
	ReturnType<typeof OnShiftDown>	|
	ReturnType<typeof OnShiftUp>	|
	ReturnType<typeof OnAltDown>	|
	ReturnType<typeof OnAltUp>		|
	ReturnType<typeof OnPlusDown>	|
	ReturnType<typeof OnMinusDown>	|
	ReturnType<typeof OnDeleteDown> |
	ReturnType<typeof OnShiftDeleteDown> |
	ReturnType<typeof OnLeftDown> |
	ReturnType<typeof OnRightDown> |
	ReturnType<typeof OnUpDown> |
	ReturnType<typeof OnDownDown> |
	ReturnType<typeof OnShiftLeftDown> |
	ReturnType<typeof OnShiftRightDown> |
	ReturnType<typeof OnShiftUpDown> |
	ReturnType<typeof OnShiftDownDown>